import { Modal } from "react-bootstrap";

interface IDialogHeader {
    title: string
}

function DialogHeader(props:IDialogHeader) {
    return (
        <Modal.Header {...props}>
            <Modal.Title className="mb-0">{props.title}</Modal.Title>
        </Modal.Header>
    );
}

export default DialogHeader;
